import { Selector } from '@ngxs/store';
import { UserStatusBrickSettingRemoteDto } from 'src/generated/swagger';
import { UserStatusBrickSettingsState, UserStatusBrickSettingsStateModel } from './user-status-brick-settings.state';

export class UserStatusBrickSettingsStateSelectors {
   @Selector([UserStatusBrickSettingsState, UserStatusBrickSettingsState.getSettingModelFn])
   public static getIsBackgroundImageShown(
      state: UserStatusBrickSettingsStateModel,
      getSettingModelFn: (state, brickInstanceId) => UserStatusBrickSettingRemoteDto
   ) {
      return (brickId: string) => {
         return getSettingModelFn(state, brickId).showBackgroundImage;
      };
   }

   @Selector([UserStatusBrickSettingsState, UserStatusBrickSettingsState.getSettingModelFn])
   public static getIsUsernameShown(state: UserStatusBrickSettingsStateModel, getSettingModelFn: (state, brickInstanceId) => UserStatusBrickSettingRemoteDto) {
      return (brickId: string) => {
         return getSettingModelFn(state, brickId).showUsername;
      };
   }

   @Selector([UserStatusBrickSettingsState, UserStatusBrickSettingsState.getSettingModelFn])
   public static getIsPrivateDnShown(state: UserStatusBrickSettingsStateModel, getSettingModelFn: (state, brickInstanceId) => UserStatusBrickSettingRemoteDto) {
      return (brickId: string) => {
         return getSettingModelFn(state, brickId).showPrivateDn;
      };
   }

   @Selector([UserStatusBrickSettingsState, UserStatusBrickSettingsState.getSettingModelFn])
   public static getIsAvatarShown(state: UserStatusBrickSettingsStateModel, getSettingModelFn: (state, brickInstanceId) => UserStatusBrickSettingRemoteDto) {
      return (brickId: string) => {
         return getSettingModelFn(state, brickId).showAvatar;
      };
   }

   @Selector([UserStatusBrickSettingsState, UserStatusBrickSettingsState.getSettingModelFn])
   public static getIsAlternativeDeviceEditorShown(
      state: UserStatusBrickSettingsStateModel,
      getSettingModelFn: (state, brickInstanceId) => UserStatusBrickSettingRemoteDto
   ) {
      return (brickId: string) => {
         return getSettingModelFn(state, brickId).showAlternativeDeviceEditor;
      };
   }

   @Selector([UserStatusBrickSettingsState, UserStatusBrickSettingsState.getSettingModelFn])
   public static getIsStatusDropdownShown(
      state: UserStatusBrickSettingsStateModel,
      getSettingModelFn: (state, brickInstanceId) => UserStatusBrickSettingRemoteDto
   ) {
      return (brickId: string) => {
         return getSettingModelFn(state, brickId).showStatusDropdown;
      };
   }
}
